export const getAccessToken = () => localStorage.getItem('token')?.slice(1, -1);

export const setTokens = (authRes: any) => {
  localStorage.setItem('token', JSON.stringify(authRes));
};
export const isAuthenticated = () => (getAccessToken() ? true : false);
export const clearLocalStorage = () => {
  localStorage.clear();
};
